// In order to allow us to fetch any data for draft content always we need to specify the status
export const ALLOWED_CONTENT_STATUSES = ['current', 'draft', 'archived'];
